import {
  Eye, MousePointer, UserCheck, Crown,
  Facebook, Search, Linkedin, Mail, Globe,
  Clock, Rocket, PauseCircle, CheckCircle2,
} from "lucide-react";
import type { Campaign, Scenario } from "./types";

export const FUNNEL_STAGES = [
  { key: "visitors", label: "Visiteurs", icon: Eye, value: 24800, color: "hsl(var(--primary))" },
  { key: "leads", label: "Leads", icon: MousePointer, value: 3720, color: "hsl(220 70% 55%)" },
  { key: "prospects", label: "Prospects", icon: UserCheck, value: 892, color: "hsl(38 90% 55%)" },
  { key: "clients", label: "Clients", icon: Crown, value: 134, color: "hsl(150 60% 45%)" },
];

export const CHANNELS = [
  { id: "facebook", name: "Facebook / Instagram Ads", icon: Facebook, color: "hsl(220 70% 55%)" },
  { id: "google", name: "Google Ads", icon: Search, color: "hsl(38 90% 55%)" },
  { id: "linkedin", name: "LinkedIn", icon: Linkedin, color: "hsl(210 80% 45%)" },
  { id: "email", name: "Email Marketing", icon: Mail, color: "hsl(330 70% 55%)" },
  { id: "seo", name: "SEO / Organique", icon: Globe, color: "hsl(150 60% 45%)" },
];

export const PIPELINE_STAGES = ["draft", "active", "paused", "completed"];

export const STAGE_LABELS: Record<string, string> = {
  draft: "Brouillon",
  active: "En cours",
  paused: "En pause",
  completed: "Terminée",
};

export const STAGE_COLORS: Record<string, string> = {
  draft: "bg-muted text-muted-foreground",
  active: "bg-emerald-500/20 text-emerald-400",
  paused: "bg-amber-500/20 text-amber-400",
  completed: "bg-primary/20 text-primary",
};

export const STAGE_ICONS: Record<string, any> = {
  draft: Clock,
  active: Rocket,
  paused: PauseCircle,
  completed: CheckCircle2,
};

export const DEFAULT_CAMPAIGNS: Campaign[] = [
  { id: "1", name: "Lancement Printemps 2026", channel: "facebook", status: "active", budget: 2500, spent: 1200, stage: "active", createdAt: "2026-03-15", isOrganic: false, landingUrl: "", imageUrl: "", cpc: 0.85, cpl: 4.20, conversions: 48, clicks: 1412 },
  { id: "2", name: "Lead Magnet B2B", channel: "linkedin", status: "active", budget: 1800, spent: 600, stage: "active", createdAt: "2026-03-20", isOrganic: false, landingUrl: "", imageUrl: "", cpc: 2.10, cpl: 8.50, conversions: 22, clicks: 286 },
  { id: "3", name: "Remarketing Panier", channel: "google", status: "draft", budget: 800, spent: 0, stage: "draft", createdAt: "2026-03-28", isOrganic: false, landingUrl: "", imageUrl: "", cpc: 0, cpl: 0, conversions: 0, clicks: 0 },
  { id: "4", name: "Séquence Onboarding", channel: "email", status: "completed", budget: 200, spent: 200, stage: "completed", createdAt: "2026-02-01", isOrganic: false, landingUrl: "", imageUrl: "", cpc: 0.12, cpl: 1.80, conversions: 89, clicks: 1667 },
  { id: "5", name: "Contenu Blog SEO", channel: "seo", status: "active", budget: 0, spent: 0, stage: "active", createdAt: "2026-03-01", isOrganic: true, landingUrl: "https://grafton.fr/blog", imageUrl: "", cpc: 0, cpl: 0, conversions: 34, clicks: 2890 },
];

export const DEFAULT_SCENARIOS: Scenario[] = [
  {
    id: "s1", name: "Acquisition Lead B2B", campaignId: "2",
    steps: [
      { id: "st1", label: "Pub LinkedIn → Landing Page", type: "action", completed: true },
      { id: "st2", label: "Attendre 24h", type: "wait", completed: true },
      { id: "st3", label: "Email de bienvenue + Lead Magnet", type: "action", completed: true },
      { id: "st4", label: "Attendre 3 jours", type: "wait", completed: false },
      { id: "st5", label: "Si ouvert → Email offre", type: "condition", completed: false },
      { id: "st6", label: "Appel commercial", type: "action", completed: false },
    ],
  },
];
